/**
 * Điểm vào của SPA — thay `app/layout.tsx` của Next.
 *
 * `app/layout.tsx` gộp ba việc: khung `<html>/<body>`, nạp font, và bọc
 * `<Providers>`. Trong SPA hai việc đầu chuyển sang `index.html` và
 * `globals.css`, chỉ còn phần providers ở đây.
 *
 * Thứ tự provider KHÁC bản Next, và không tuỳ tiện:
 *
 *   QueryClientProvider  (ngoài — không cần biết gì về router)
 *     └─ RouterProvider
 *          └─ AuthProvider   (trong — xem RootLayout ở router.tsx)
 *
 * `AuthProvider` gọi `useNavigate()` để đá người dùng về `/login` khi phiên hết
 * hạn, mà hook đó chỉ chạy được bên trong router. Đặt `AuthProvider` ra ngoài
 * `RouterProvider` sẽ ném lỗi ngay khi khởi động.
 *
 * KHÔNG dùng `<StrictMode>` trong lần chuyển này. StrictMode gọi effect hai lần
 * ở dev, mà nhiều hook trong repo đăng ký socket, service worker và vòng
 * bootstrap refresh token — bật lên sẽ sinh ra lỗi chỉ-có-ở-dev và trộn lẫn với
 * lỗi thật của migration. Bật lại là việc riêng, sau khi đã ổn định.
 */

import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { QueryProvider } from './app/query-provider';
import { router } from './router';
import './app/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Không tìm thấy #root trong index.html');
}

createRoot(container).render(
  <QueryProvider>
    <RouterProvider router={router} />
  </QueryProvider>,
);
